import _ from 'lodash';

export default function getEnumEntries(myEnum: any) {
    return _.chain(Object.entries(myEnum))
        .filter(([, y]) => _.isNumber(y))
        .map(([x, y]) => ({ key: x, value: parseInt(y as any, 10) }))
        .value();
}
